export const SortPages = {
  Inventory: 'inventory',
  Tree: 'tree',
  Task: 'task',
  TreeInspection: 'treeInspection'
}
